import ChatListItem from "./ChatListItem";

/**
 * Component que renderitza la llista complerta de xats (historial)
 * a la barra lateral de l'aplicació.
 * 
 * @param {Object} props - Llistat de xats i estats per repartir als fills.
 */
export default function ChatList({
  chats, activeChatId, favourites,
  deletingId, favFadingId, flashTitleId,
  openMenuId, setOpenMenuId,
  toggleFavourite, onSelect, onRename, onConfirmDelete,
}) {
  return (
    <ul id="onb-chat-list" className="chat-list">
      {chats.map(chat => (
        <ChatListItem
          key={chat.id}
          chat={chat}
          isActive={String(chat.id) === String(activeChatId)}
          deletingId={deletingId}
          favFadingId={favFadingId}
          flashTitleId={flashTitleId}
          favourites={favourites}
          openMenuId={openMenuId}
          setOpenMenuId={setOpenMenuId}
          toggleFavourite={toggleFavourite}
          onSelect={onSelect}
          onRename={onRename}
          onConfirmDelete={onConfirmDelete}
        />
      ))}
    </ul>
  );
}
